// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* =========================================
   CORE THEME — Clean, Modern, Conference UI
   ========================================= */
/* Import Section Styles */
.scrolling-text-section {
  background-color: var(--surface, #f9f9f9);
  padding: 30px 0;
  margin: 20px 0;
  overflow: hidden;
  border-top: 1px solid rgba(207, 171, 141, 0.2);
  border-bottom: 1px solid rgba(207, 171, 141, 0.2);
}
.scrolling-text-section .scrolling-text-container {
  width: 100%;
  overflow: hidden;
  background: linear-gradient(to right, transparent, rgba(207, 171, 141, 0.1), transparent);
  padding: 10px 0;
}
.scrolling-text-section .scrolling-text {
  display: flex;
  animation: scroll-left 20s linear infinite;
}
.scrolling-text-section .scrolling-text p {
  margin: 0;
  white-space: nowrap;
  padding: 15px 50px;
  font-size: 16px;
  font-weight: 500;
  color: var(--ink, #111);
}
.scrolling-text-section .scrolling-text p a {
  color: var(--accent, #CFAB8D);
  text-decoration: none;
  font-weight: 600;
}
.scrolling-text-section .scrolling-text p a:hover {
  text-decoration: underline;
}

@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.scrolling-images-section {
  background-color: var(--bg, #ECEEDF);
  padding: 60px 0;
  margin: 20px 0;
  overflow: hidden;
}
.scrolling-images-section .scrolling-images-container {
  width: 100%;
  overflow: hidden;
}
.scrolling-images-section .scrolling-images {
  display: flex;
  animation: scroll-images 30s linear infinite;
  gap: 20px;
  padding: 20px 0;
}
.scrolling-images-section .scrolling-image {
  flex: 0 0 200px;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}
.scrolling-images-section .scrolling-image:hover {
  transform: scale(1.05);
}

@keyframes scroll-images {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.countdown-timer {
  background-color: var(--surface, #f9f9f9);
  padding: 80px 0;
  margin: 20px 0;
}
.countdown-timer .heading-count {
  margin-bottom: 50px;
  text-align: center;
}
.countdown-timer .heading-count h2 {
  font-size: 32px;
  font-weight: 700;
  color: var(--ink, #111);
  margin: 0 0 20px 0;
}
.countdown-timer .time-countdown {
  margin-bottom: 60px;
}
.countdown-timer .time-countdown ul {
  list-style: none;
  padding: 0;
  text-align: justify;
}
.countdown-timer .time-countdown ul li {
  margin-bottom: 18px;
  padding: 12px 0;
  font-size: 14px;
  line-height: 1.8;
  color: var(--ink, #111);
  border-bottom: 1px solid rgba(207, 171, 141, 0.1);
}
.countdown-timer .time-countdown ul li:last-child {
  border-bottom: none;
}
.countdown-timer .time-countdown ul li a {
  color: var(--accent, #CFAB8D);
  text-decoration: none;
  font-weight: 500;
}
.countdown-timer .time-countdown ul li a:hover {
  text-decoration: underline;
}
.countdown-timer .time-countdown ul li .flash-red {
  color: #e74c3c;
  font-weight: 600;
  animation: flash 1s infinite;
}
.countdown-timer .registration-table {
  width: 100%;
  border-collapse: collapse;
  margin: 50px 0;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));
}
.countdown-timer .registration-table thead {
  background-color: var(--accent, #CFAB8D);
  color: white;
}
.countdown-timer .registration-table thead th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
}
.countdown-timer .registration-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}
.countdown-timer .registration-table tbody tr:hover {
  background-color: rgba(207, 171, 141, 0.1);
}
.countdown-timer .registration-table tbody tr td {
  padding: 16px;
  font-size: 14px;
  color: var(--ink, #111);
}
.countdown-timer .registration-note2,
.countdown-timer .registration-note {
  background-color: #fff3cd;
  border-left: 4px solid var(--accent, #CFAB8D);
  padding: 18px;
  margin: 20px 0;
  border-radius: 4px;
  font-size: 14px;
  color: var(--ink, #111);
  line-height: 1.6;
}

@keyframes flash {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.important-dates {
  background-color: var(--bg, #ECEEDF);
  padding: 80px 0;
  margin: 20px 0;
}
.important-dates h2 {
  font-size: 32px;
  font-weight: 700;
  color: var(--ink, #111);
  margin-bottom: 50px;
  text-align: center;
}
.important-dates .table {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));
  margin-bottom: 40px;
}
.important-dates .table thead {
  background-color: var(--accent, #CFAB8D);
  color: white;
}
.important-dates .table thead th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  border: none;
}
.important-dates .table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}
.important-dates .table tbody tr:hover {
  background-color: rgba(207, 171, 141, 0.1);
}
.important-dates .table tbody tr td {
  padding: 16px;
  font-size: 14px;
  color: var(--ink, #111);
  border: none;
  line-height: 1.6;
}
.important-dates .table tbody tr td strong {
  color: var(--accent, #CFAB8D);
  font-weight: 600;
}

#sponsor_ribbon {
  background-color: var(--surface, #f9f9f9);
  padding: 80px 0;
  margin: 20px 0;
}
#sponsor_ribbon .sponsor-container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
  align-items: center;
}
#sponsor_ribbon .sponsor-container a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
#sponsor_ribbon .sponsor-container a:hover {
  transform: scale(1.1);
  opacity: 0.8;
}
#sponsor_ribbon .sponsor-container .sponsor-logo {
  max-height: 80px;
  object-fit: contain;
  filter: grayscale(30%);
  transition: filter 0.3s ease;
}
#sponsor_ribbon .sponsor-container .sponsor-logo:hover {
  filter: grayscale(0%);
}

@media (max-width: 768px) {
  .scrolling-text-section {
    padding: 20px 0;
    margin: 15px 0;
  }
  .scrolling-text-section .scrolling-text p {
    padding: 12px 30px;
    font-size: 14px;
  }
  .scrolling-images-section {
    padding: 40px 0;
    margin: 15px 0;
  }
  .scrolling-images-section .scrolling-images {
    gap: 15px;
    padding: 15px 0;
  }
  .scrolling-image {
    flex: 0 0 150px !important;
    height: 120px !important;
  }
  .countdown-timer {
    padding: 60px 0;
    margin: 15px 0;
  }
  .countdown-timer .heading-count {
    margin-bottom: 40px;
  }
  .countdown-timer .heading-count h2 {
    font-size: 26px;
    margin-bottom: 15px;
  }
  .countdown-timer .time-countdown {
    margin-bottom: 40px;
  }
  .countdown-timer .time-countdown ul li {
    margin-bottom: 15px;
    padding: 10px 0;
    font-size: 13px;
  }
  .countdown-timer .registration-table,
  .countdown-timer .table {
    font-size: 12px;
    margin: 30px 0;
  }
  .countdown-timer .registration-table th, .countdown-timer .registration-table td,
  .countdown-timer .table th,
  .countdown-timer .table td {
    padding: 12px !important;
  }
  .countdown-timer .registration-note2,
  .countdown-timer .registration-note {
    padding: 15px;
    margin: 15px 0;
    font-size: 13px;
  }
  .important-dates {
    padding: 60px 0;
    margin: 15px 0;
  }
  .important-dates h2 {
    font-size: 26px;
    margin-bottom: 40px;
  }
  .important-dates .table {
    font-size: 12px;
  }
  .important-dates .table th, .important-dates .table td {
    padding: 12px !important;
  }
  #sponsor_ribbon {
    padding: 60px 0;
    margin: 15px 0;
  }
  #sponsor_ribbon .sponsor-container {
    gap: 25px;
  }
  #sponsor_ribbon .sponsor-container .sponsor-logo {
    max-height: 70px;
  }
}
@media (max-width: 576px) {
  .scrolling-text-section {
    padding: 15px 0;
    margin: 10px 0;
  }
  .scrolling-text-section .scrolling-text p {
    padding: 10px 20px;
    font-size: 13px;
  }
  .scrolling-images-section {
    padding: 30px 0;
    margin: 10px 0;
  }
  .scrolling-images-section .scrolling-images {
    gap: 10px;
    padding: 10px 0;
  }
  .scrolling-image {
    flex: 0 0 120px !important;
    height: 100px !important;
  }
  .countdown-timer {
    padding: 40px 0;
    margin: 10px 0;
  }
  .countdown-timer .heading-count {
    margin-bottom: 30px;
  }
  .countdown-timer .heading-count h2 {
    font-size: 22px;
    margin-bottom: 15px;
  }
  .countdown-timer .time-countdown {
    margin-bottom: 30px;
  }
  .countdown-timer .time-countdown ul li {
    margin-bottom: 12px;
    padding: 8px 0;
    font-size: 12px;
  }
  .countdown-timer .registration-table,
  .countdown-timer .table {
    font-size: 11px;
    margin: 20px 0;
  }
  .countdown-timer .registration-table th, .countdown-timer .registration-table td,
  .countdown-timer .table th,
  .countdown-timer .table td {
    padding: 10px !important;
    font-size: 11px;
  }
  .countdown-timer .registration-note2,
  .countdown-timer .registration-note {
    padding: 12px;
    margin: 12px 0;
    font-size: 12px;
  }
  .important-dates {
    padding: 40px 0;
    margin: 10px 0;
  }
  .important-dates h2 {
    font-size: 22px;
    margin-bottom: 30px;
  }
  .important-dates .table {
    font-size: 11px;
  }
  .important-dates .table th, .important-dates .table td {
    padding: 10px !important;
  }
  #sponsor_ribbon {
    padding: 40px 0;
    margin: 10px 0;
  }
  #sponsor_ribbon .sponsor-container {
    gap: 15px;
  }
  #sponsor_ribbon .sponsor-container .sponsor-logo {
    max-height: 60px;
  }
}
:root {
  /* Brand / accent colors */
  --accent: #CFAB8D;
  --accent-2: #D9C4B0;
  /* Neutrals */
  --bg: #eef1dd;
  --surface: #ffffff;
  --ink: #1c1f22;
  --ink-muted: #6b7075;
  /* Effects */
  --shadow-lg: 0 10px 32px rgba(20, 24, 30, 0.08);
  --shadow-sm: 0 4px 16px rgba(20, 24, 30, 0.05);
  --radius: 12px;
  /* Layout */
  --max-width: 1200px;
  --spacing: 1.25rem;
}

/* =========================================
   RESET & TYPOGRAPHY
   ========================================= */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  overflow-x: hidden;
  max-width: 100%;
}

body {
  font-family: "Inter", system-ui, sans-serif;
  background: var(--bg);
  color: var(--ink-muted);
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4 {
  font-family: "Merriweather", serif;
  color: var(--ink);
  margin-bottom: 0.6rem;
}

h1 {
  font-size: clamp(28px, 5vw, 48px);
}

h2 {
  font-size: clamp(22px, 3vw, 32px);
}

p {
  margin-bottom: 1rem;
}

/* =========================================
   LAYOUT HELPERS
   ========================================= */
.container {
  max-width: var(--max-width);
  width: 100%;
  margin: 0 auto;
  padding: 0 var(--spacing);
}

.section {
  padding: 64px 0;
}

.section-tight {
  padding: 40px 0;
}

.text-center {
  text-align: center;
}

/* =========================================
   BUTTONS — simple, clean, modern
   ========================================= */
.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  transition: 0.18s ease;
}

.btn-primary {
  background: linear-gradient(90deg, var(--accent), var(--accent-2));
  color: #fff;
  box-shadow: var(--shadow-sm);
}

.btn-primary:hover {
  opacity: 0.92;
  box-shadow: var(--shadow-lg);
}

.btn-ghost {
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: var(--ink);
}

.btn-ghost:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* Small variant */
.btn-sm {
  padding: 0.4rem 0.8rem;
  font-size: 0.9rem;
}

/* =========================================
   CARDS
   ========================================= */
.card {
  background: var(--surface);
  padding: 24px;
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.card-pad {
  padding: 32px;
}

/* =========================================
   FORMS (clean & accessible)
   ========================================= */
label {
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 0.35rem;
  display: block;
}

input, select, textarea {
  width: 100%;
  padding: 0.65rem 0.8rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;
  font-size: 1rem;
  color: var(--ink);
}

/* =========================================
   TABLES (pricing / registration)
   ========================================= */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.table thead th {
  background: #0b6e4f;
  color: #fff;
  padding: 14px 12px;
  font-weight: 700;
}

.table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table .highlight {
  background: rgba(55, 179, 138, 0.08);
}

/* =========================================
   HERO / CAROUSEL (clean & minimal)
   ========================================= */
.carousel-container {
  position: relative;
}

.carousel-container .carousel-item::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(2, 6, 8, 0.45), rgba(2, 6, 8, 0.15));
  z-index: 1;
}

.carousel-caption {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  text-align: center;
  max-width: var(--max-width);
  padding: 1rem;
}

.carousel-caption h1,
.carousel-caption p {
  color: #fff;
}

/* =========================================
   RESPONSIVE
   ========================================= */
@media (max-width: 992px) {
  .section {
    padding: 48px 0;
  }
  h1 {
    font-size: 34px;
  }
}
@media (max-width: 576px) {
  .section {
    padding: 28px 0;
  }
  h1 {
    font-size: 26px;
  }
  .carousel-caption {
    padding: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/components/sections.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;8CAAA;AAIA,0BAAA;ACHA;EACE,yCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,8CAAA;EACA,iDAAA;ADKF;ACHE;EACE,WAAA;EACA,gBAAA;EACA,yFAAA;EACA,eAAA;ADKJ;ACFE;EACE,aAAA;EACA,0CAAA;ADIJ;ACFI;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;ADIN;ACFM;EACE,6BAAA;EACA,qBAAA;EACA,gBAAA;ADIR;ACFQ;EACE,0BAAA;ADIV;;ACGA;EACE;IACE,2BAAA;EDAF;ECEA;IACE,4BAAA;EDAF;AACF;ACIA;EACE,oCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ADFF;ACIE;EACE,WAAA;EACA,gBAAA;ADFJ;ACKE;EACE,aAAA;EACA,4CAAA;EACA,SAAA;EACA,eAAA;ADHJ;ACME;EACE,eAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,0DAAA;EACA,+BAAA;ADJJ;ACMI;EACE,sBAAA;ADJN;;ACSA;EACE;IACE,wBAAA;EDNF;ECQA;IACE,2BAAA;EDNF;AACF;ACUA;EACE,yCAAA;EACA,eAAA;EACA,cAAA;ADRF;ACUE;EACE,mBAAA;EACA,kBAAA;ADRJ;ACUI;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;ADRN;ACYE;EACE,mBAAA;ADVJ;ACYI;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;ADVN;ACYM;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDAAA;ADVR;ACYQ;EACE,mBAAA;ADVV;ACaQ;EACE,6BAAA;EACA,qBAAA;EACA,gBAAA;ADXV;ACaU;EACE,0BAAA;ADXZ;ACeQ;EACE,cAAA;EACA,gBAAA;EACA,4BAAA;ADbV;ACmBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0DAAA;ADjBJ;ACmBI;EACE,wCAAA;EACA,YAAA;ADjBN;ACmBM;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ADjBR;ACsBM;EACE,gCAAA;ADpBR;ACsBQ;EACE,0CAAA;ADpBV;ACuBQ;EACE,aAAA;EACA,eAAA;EACA,uBAAA;ADrBV;AC2BE;;EAEE,yBAAA;EACA,6CAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;ADzBJ;;AC6BA;EACE;IACE,UAAA;ED1BF;EC4BA;IACE,YAAA;ED1BF;AACF;AC8BA;EACE,oCAAA;EACA,eAAA;EACA,cAAA;AD5BF;AC8BE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AD5BJ;AC+BE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0DAAA;EACA,mBAAA;AD7BJ;AC+BI;EACE,wCAAA;EACA,YAAA;AD7BN;AC+BM;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AD7BR;ACkCM;EACE,gCAAA;ADhCR;ACkCQ;EACE,0CAAA;ADhCV;ACmCQ;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;ADjCV;ACmCU;EACE,6BAAA;EACA,gBAAA;ADjCZ;;AC0CA;EACE,yCAAA;EACA,eAAA;EACA,cAAA;ADvCF;ACyCE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;ADvCJ;ACyCI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kDAAA;ADvCN;ACyCM;EACE,qBAAA;EACA,YAAA;ADvCR;AC2CI;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;ADzCN;AC2CM;EACE,qBAAA;ADzCR;;ACgDA;EACE;IACE,eAAA;IACA,cAAA;ED7CF;EC+CE;IACE,kBAAA;IACA,eAAA;ED7CJ;ECiDA;IACE,eAAA;IACA,cAAA;ED/CF;ECiDE;IACE,SAAA;IACA,eAAA;ED/CJ;ECmDA;IACE,0BAAA;IACA,wBAAA;EDjDF;ECoDA;IACE,eAAA;IACA,cAAA;EDlDF;ECoDE;IACE,mBAAA;EDlDJ;ECoDI;IACE,eAAA;IACA,mBAAA;EDlDN;ECsDE;IACE,mBAAA;EDpDJ;ECsDI;IACE,mBAAA;IACA,eAAA;IACA,eAAA;EDpDN;ECwDE;;IAEE,eAAA;IACA,cAAA;EDtDJ;ECwDI;;;IACE,wBAAA;EDpDN;ECwDE;;IAEE,aAAA;IACA,cAAA;IACA,eAAA;EDtDJ;EC0DA;IACE,eAAA;IACA,cAAA;EDxDF;EC0DE;IACE,eAAA;IACA,mBAAA;EDxDJ;EC2DE;IACE,eAAA;EDzDJ;EC2DI;IACE,wBAAA;EDzDN;EC8DA;IACE,eAAA;IACA,cAAA;ED5DF;EC8DE;IACE,SAAA;ED5DJ;EC8DI;IACE,gBAAA;ED5DN;AACF;ACiEA;EACE;IACE,eAAA;IACA,cAAA;ED/DF;ECiEE;IACE,kBAAA;IACA,eAAA;ED/DJ;ECmEA;IACE,eAAA;IACA,cAAA;EDjEF;ECmEE;IACE,SAAA;IACA,eAAA;EDjEJ;ECqEA;IACE,0BAAA;IACA,wBAAA;EDnEF;ECsEA;IACE,eAAA;IACA,cAAA;EDpEF;ECsEE;IACE,mBAAA;EDpEJ;ECsEI;IACE,eAAA;IACA,mBAAA;EDpEN;ECwEE;IACE,mBAAA;EDtEJ;ECwEI;IACE,mBAAA;IACA,cAAA;IACA,eAAA;EDtEN;EC0EE;;IAEE,eAAA;IACA,cAAA;EDxEJ;EC0EI;;;IACE,wBAAA;IACA,eAAA;EDtEN;EC0EE;;IAEE,aAAA;IACA,cAAA;IACA,eAAA;EDxEJ;EC4EA;IACE,eAAA;IACA,cAAA;ED1EF;EC4EE;IACE,eAAA;IACA,mBAAA;ED1EJ;EC6EE;IACE,eAAA;ED3EJ;EC6EI;IACE,wBAAA;ED3EN;ECgFA;IACE,eAAA;IACA,cAAA;ED9EF;ECgFE;IACE,SAAA;ED9EJ;ECgFI;IACE,gBAAA;ED9EN;AACF;AA/ZA;EACE,0BAAA;EACA,iBAAA;EACA,mBAAA;EAEA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EAEA,YAAA;EACA,+CAAA;EACA,8CAAA;EACA,cAAA;EAEA,WAAA;EACA,mBAAA;EACA,kBAAA;AA8ZF;;AA3ZA;;8CAAA;AAGA;EAAI,sBAAA;EAAwB,SAAA;EAAW,UAAA;AAiavC;;AA/ZA;EACE,kBAAA;EACA,eAAA;AAkaF;;AA/ZA;EACE,2CAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mCAAA;AAkaF;;AA/ZA;EACE,kCAAA;EACA,iBAAA;EACA,qBAAA;AAkaF;;AA/ZA;EAAK,iCAAA;AAmaL;;AAlaA;EAAK,iCAAA;AAsaL;;AApaA;EAAI,mBAAA;AAwaJ;;AAtaA;;8CAAA;AAGA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;AAyaF;;AAtaA;EAAW,eAAA;AA0aX;;AAzaA;EAAiB,eAAA;AA6ajB;;AA5aA;EAAe,kBAAA;AAgbf;;AA9aA;;8CAAA;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;AAibF;;AA9aA;EACE,kEAAA;EACA,WAAA;EACA,4BAAA;AAibF;;AA9aA;EACE,aAAA;EACA,4BAAA;AAibF;;AA9aA;EACE,uBAAA;EACA,oCAAA;EACA,iBAAA;AAibF;;AA9aA;EACE,+BAAA;AAibF;;AA9aA,kBAAA;AACA;EAAU,sBAAA;EAAsB,iBAAA;AAmbhC;;AAjbA;;8CAAA;AAGA;EACE,0BAAA;EACA,aAAA;EACA,4BAAA;EACA,4BAAA;AAobF;;AAjbA;EACE,aAAA;AAobF;;AAjbA;;8CAAA;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAobF;;AAjbA;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAobF;;AAjbA;;8CAAA;AAGA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAobF;;AAjbA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAobF;;AAjbA;EACE,kBAAA;EACA,4CAAA;AAobF;;AAjbA;EACE,oCAAA;AAobF;;AAjbA;;8CAAA;AAGA;EACE,kBAAA;AAobF;;AAjbA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6EAAA;EAKA,UAAA;AAgbF;;AA7aA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;AAgbF;;AA7aA;;EAEE,WAAA;AAgbF;;AA7aA;;8CAAA;AAGA;EACE;IAAW,eAAA;EAibX;EAhbA;IAAK,eAAA;EAmbL;AACF;AAjbA;EACE;IAAW,eAAA;EAobX;EAnbA;IAAK,eAAA;EAsbL;EArbA;IAAoB,eAAA;EAwbpB;AACF","sourcesContent":["@charset \"UTF-8\";\n/* =========================================\n   CORE THEME — Clean, Modern, Conference UI\n   ========================================= */\n/* Import Section Styles */\n.scrolling-text-section {\n  background-color: var(--surface, #f9f9f9);\n  padding: 30px 0;\n  margin: 20px 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(207, 171, 141, 0.2);\n  border-bottom: 1px solid rgba(207, 171, 141, 0.2);\n}\n.scrolling-text-section .scrolling-text-container {\n  width: 100%;\n  overflow: hidden;\n  background: linear-gradient(to right, transparent, rgba(207, 171, 141, 0.1), transparent);\n  padding: 10px 0;\n}\n.scrolling-text-section .scrolling-text {\n  display: flex;\n  animation: scroll-left 20s linear infinite;\n}\n.scrolling-text-section .scrolling-text p {\n  margin: 0;\n  white-space: nowrap;\n  padding: 15px 50px;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--ink, #111);\n}\n.scrolling-text-section .scrolling-text p a {\n  color: var(--accent, #CFAB8D);\n  text-decoration: none;\n  font-weight: 600;\n}\n.scrolling-text-section .scrolling-text p a:hover {\n  text-decoration: underline;\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n.scrolling-images-section {\n  background-color: var(--bg, #ECEEDF);\n  padding: 60px 0;\n  margin: 20px 0;\n  overflow: hidden;\n}\n.scrolling-images-section .scrolling-images-container {\n  width: 100%;\n  overflow: hidden;\n}\n.scrolling-images-section .scrolling-images {\n  display: flex;\n  animation: scroll-images 30s linear infinite;\n  gap: 20px;\n  padding: 20px 0;\n}\n.scrolling-images-section .scrolling-image {\n  flex: 0 0 200px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 8px;\n  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n  transition: transform 0.3s ease;\n}\n.scrolling-images-section .scrolling-image:hover {\n  transform: scale(1.05);\n}\n\n@keyframes scroll-images {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n.countdown-timer {\n  background-color: var(--surface, #f9f9f9);\n  padding: 80px 0;\n  margin: 20px 0;\n}\n.countdown-timer .heading-count {\n  margin-bottom: 50px;\n  text-align: center;\n}\n.countdown-timer .heading-count h2 {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--ink, #111);\n  margin: 0 0 20px 0;\n}\n.countdown-timer .time-countdown {\n  margin-bottom: 60px;\n}\n.countdown-timer .time-countdown ul {\n  list-style: none;\n  padding: 0;\n  text-align: justify;\n}\n.countdown-timer .time-countdown ul li {\n  margin-bottom: 18px;\n  padding: 12px 0;\n  font-size: 14px;\n  line-height: 1.8;\n  color: var(--ink, #111);\n  border-bottom: 1px solid rgba(207, 171, 141, 0.1);\n}\n.countdown-timer .time-countdown ul li:last-child {\n  border-bottom: none;\n}\n.countdown-timer .time-countdown ul li a {\n  color: var(--accent, #CFAB8D);\n  text-decoration: none;\n  font-weight: 500;\n}\n.countdown-timer .time-countdown ul li a:hover {\n  text-decoration: underline;\n}\n.countdown-timer .time-countdown ul li .flash-red {\n  color: #e74c3c;\n  font-weight: 600;\n  animation: flash 1s infinite;\n}\n.countdown-timer .registration-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 50px 0;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n}\n.countdown-timer .registration-table thead {\n  background-color: var(--accent, #CFAB8D);\n  color: white;\n}\n.countdown-timer .registration-table thead th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n}\n.countdown-timer .registration-table tbody tr {\n  border-bottom: 1px solid #e0e0e0;\n}\n.countdown-timer .registration-table tbody tr:hover {\n  background-color: rgba(207, 171, 141, 0.1);\n}\n.countdown-timer .registration-table tbody tr td {\n  padding: 16px;\n  font-size: 14px;\n  color: var(--ink, #111);\n}\n.countdown-timer .registration-note2,\n.countdown-timer .registration-note {\n  background-color: #fff3cd;\n  border-left: 4px solid var(--accent, #CFAB8D);\n  padding: 18px;\n  margin: 20px 0;\n  border-radius: 4px;\n  font-size: 14px;\n  color: var(--ink, #111);\n  line-height: 1.6;\n}\n\n@keyframes flash {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n.important-dates {\n  background-color: var(--bg, #ECEEDF);\n  padding: 80px 0;\n  margin: 20px 0;\n}\n.important-dates h2 {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--ink, #111);\n  margin-bottom: 50px;\n  text-align: center;\n}\n.important-dates .table {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n  margin-bottom: 40px;\n}\n.important-dates .table thead {\n  background-color: var(--accent, #CFAB8D);\n  color: white;\n}\n.important-dates .table thead th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 600;\n  border: none;\n}\n.important-dates .table tbody tr {\n  border-bottom: 1px solid #e0e0e0;\n}\n.important-dates .table tbody tr:hover {\n  background-color: rgba(207, 171, 141, 0.1);\n}\n.important-dates .table tbody tr td {\n  padding: 16px;\n  font-size: 14px;\n  color: var(--ink, #111);\n  border: none;\n  line-height: 1.6;\n}\n.important-dates .table tbody tr td strong {\n  color: var(--accent, #CFAB8D);\n  font-weight: 600;\n}\n\n#sponsor_ribbon {\n  background-color: var(--surface, #f9f9f9);\n  padding: 80px 0;\n  margin: 20px 0;\n}\n#sponsor_ribbon .sponsor-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 40px;\n  justify-content: center;\n  align-items: center;\n}\n#sponsor_ribbon .sponsor-container a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n#sponsor_ribbon .sponsor-container a:hover {\n  transform: scale(1.1);\n  opacity: 0.8;\n}\n#sponsor_ribbon .sponsor-container .sponsor-logo {\n  max-height: 80px;\n  object-fit: contain;\n  filter: grayscale(30%);\n  transition: filter 0.3s ease;\n}\n#sponsor_ribbon .sponsor-container .sponsor-logo:hover {\n  filter: grayscale(0%);\n}\n\n@media (max-width: 768px) {\n  .scrolling-text-section {\n    padding: 20px 0;\n    margin: 15px 0;\n  }\n  .scrolling-text-section .scrolling-text p {\n    padding: 12px 30px;\n    font-size: 14px;\n  }\n  .scrolling-images-section {\n    padding: 40px 0;\n    margin: 15px 0;\n  }\n  .scrolling-images-section .scrolling-images {\n    gap: 15px;\n    padding: 15px 0;\n  }\n  .scrolling-image {\n    flex: 0 0 150px !important;\n    height: 120px !important;\n  }\n  .countdown-timer {\n    padding: 60px 0;\n    margin: 15px 0;\n  }\n  .countdown-timer .heading-count {\n    margin-bottom: 40px;\n  }\n  .countdown-timer .heading-count h2 {\n    font-size: 26px;\n    margin-bottom: 15px;\n  }\n  .countdown-timer .time-countdown {\n    margin-bottom: 40px;\n  }\n  .countdown-timer .time-countdown ul li {\n    margin-bottom: 15px;\n    padding: 10px 0;\n    font-size: 13px;\n  }\n  .countdown-timer .registration-table,\n  .countdown-timer .table {\n    font-size: 12px;\n    margin: 30px 0;\n  }\n  .countdown-timer .registration-table th, .countdown-timer .registration-table td,\n  .countdown-timer .table th,\n  .countdown-timer .table td {\n    padding: 12px !important;\n  }\n  .countdown-timer .registration-note2,\n  .countdown-timer .registration-note {\n    padding: 15px;\n    margin: 15px 0;\n    font-size: 13px;\n  }\n  .important-dates {\n    padding: 60px 0;\n    margin: 15px 0;\n  }\n  .important-dates h2 {\n    font-size: 26px;\n    margin-bottom: 40px;\n  }\n  .important-dates .table {\n    font-size: 12px;\n  }\n  .important-dates .table th, .important-dates .table td {\n    padding: 12px !important;\n  }\n  #sponsor_ribbon {\n    padding: 60px 0;\n    margin: 15px 0;\n  }\n  #sponsor_ribbon .sponsor-container {\n    gap: 25px;\n  }\n  #sponsor_ribbon .sponsor-container .sponsor-logo {\n    max-height: 70px;\n  }\n}\n@media (max-width: 576px) {\n  .scrolling-text-section {\n    padding: 15px 0;\n    margin: 10px 0;\n  }\n  .scrolling-text-section .scrolling-text p {\n    padding: 10px 20px;\n    font-size: 13px;\n  }\n  .scrolling-images-section {\n    padding: 30px 0;\n    margin: 10px 0;\n  }\n  .scrolling-images-section .scrolling-images {\n    gap: 10px;\n    padding: 10px 0;\n  }\n  .scrolling-image {\n    flex: 0 0 120px !important;\n    height: 100px !important;\n  }\n  .countdown-timer {\n    padding: 40px 0;\n    margin: 10px 0;\n  }\n  .countdown-timer .heading-count {\n    margin-bottom: 30px;\n  }\n  .countdown-timer .heading-count h2 {\n    font-size: 22px;\n    margin-bottom: 15px;\n  }\n  .countdown-timer .time-countdown {\n    margin-bottom: 30px;\n  }\n  .countdown-timer .time-countdown ul li {\n    margin-bottom: 12px;\n    padding: 8px 0;\n    font-size: 12px;\n  }\n  .countdown-timer .registration-table,\n  .countdown-timer .table {\n    font-size: 11px;\n    margin: 20px 0;\n  }\n  .countdown-timer .registration-table th, .countdown-timer .registration-table td,\n  .countdown-timer .table th,\n  .countdown-timer .table td {\n    padding: 10px !important;\n    font-size: 11px;\n  }\n  .countdown-timer .registration-note2,\n  .countdown-timer .registration-note {\n    padding: 12px;\n    margin: 12px 0;\n    font-size: 12px;\n  }\n  .important-dates {\n    padding: 40px 0;\n    margin: 10px 0;\n  }\n  .important-dates h2 {\n    font-size: 22px;\n    margin-bottom: 30px;\n  }\n  .important-dates .table {\n    font-size: 11px;\n  }\n  .important-dates .table th, .important-dates .table td {\n    padding: 10px !important;\n  }\n  #sponsor_ribbon {\n    padding: 40px 0;\n    margin: 10px 0;\n  }\n  #sponsor_ribbon .sponsor-container {\n    gap: 15px;\n  }\n  #sponsor_ribbon .sponsor-container .sponsor-logo {\n    max-height: 60px;\n  }\n}\n:root {\n  /* Brand / accent colors */\n  --accent: #CFAB8D;\n  --accent-2: #D9C4B0;\n  /* Neutrals */\n  --bg: #eef1dd;\n  --surface: #ffffff;\n  --ink: #1c1f22;\n  --ink-muted: #6b7075;\n  /* Effects */\n  --shadow-lg: 0 10px 32px rgba(20, 24, 30, 0.08);\n  --shadow-sm: 0 4px 16px rgba(20, 24, 30, 0.05);\n  --radius: 12px;\n  /* Layout */\n  --max-width: 1200px;\n  --spacing: 1.25rem;\n}\n\n/* =========================================\n   RESET & TYPOGRAPHY\n   ========================================= */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml, body {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\nbody {\n  font-family: \"Inter\", system-ui, sans-serif;\n  background: var(--bg);\n  color: var(--ink-muted);\n  line-height: 1.65;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1, h2, h3, h4 {\n  font-family: \"Merriweather\", serif;\n  color: var(--ink);\n  margin-bottom: 0.6rem;\n}\n\nh1 {\n  font-size: clamp(28px, 5vw, 48px);\n}\n\nh2 {\n  font-size: clamp(22px, 3vw, 32px);\n}\n\np {\n  margin-bottom: 1rem;\n}\n\n/* =========================================\n   LAYOUT HELPERS\n   ========================================= */\n.container {\n  max-width: var(--max-width);\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 var(--spacing);\n}\n\n.section {\n  padding: 64px 0;\n}\n\n.section-tight {\n  padding: 40px 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/* =========================================\n   BUTTONS — simple, clean, modern\n   ========================================= */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.6rem 1.2rem;\n  border-radius: 8px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: 0.18s ease;\n}\n\n.btn-primary {\n  background: linear-gradient(90deg, var(--accent), var(--accent-2));\n  color: #fff;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-primary:hover {\n  opacity: 0.92;\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-ghost {\n  background: transparent;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: var(--ink);\n}\n\n.btn-ghost:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* Small variant */\n.btn-sm {\n  padding: 0.4rem 0.8rem;\n  font-size: 0.9rem;\n}\n\n/* =========================================\n   CARDS\n   ========================================= */\n.card {\n  background: var(--surface);\n  padding: 24px;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n}\n\n.card-pad {\n  padding: 32px;\n}\n\n/* =========================================\n   FORMS (clean & accessible)\n   ========================================= */\nlabel {\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 0.35rem;\n  display: block;\n}\n\ninput, select, textarea {\n  width: 100%;\n  padding: 0.65rem 0.8rem;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  background: #fff;\n  font-size: 1rem;\n  color: var(--ink);\n}\n\n/* =========================================\n   TABLES (pricing / registration)\n   ========================================= */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.table thead th {\n  background: #0b6e4f;\n  color: #fff;\n  padding: 14px 12px;\n  font-weight: 700;\n}\n\n.table td {\n  padding: 14px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.table .highlight {\n  background: rgba(55, 179, 138, 0.08);\n}\n\n/* =========================================\n   HERO / CAROUSEL (clean & minimal)\n   ========================================= */\n.carousel-container {\n  position: relative;\n}\n\n.carousel-container .carousel-item::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(2, 6, 8, 0.45), rgba(2, 6, 8, 0.15));\n  z-index: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 3;\n  text-align: center;\n  max-width: var(--max-width);\n  padding: 1rem;\n}\n\n.carousel-caption h1,\n.carousel-caption p {\n  color: #fff;\n}\n\n/* =========================================\n   RESPONSIVE\n   ========================================= */\n@media (max-width: 992px) {\n  .section {\n    padding: 48px 0;\n  }\n  h1 {\n    font-size: 34px;\n  }\n}\n@media (max-width: 576px) {\n  .section {\n    padding: 28px 0;\n  }\n  h1 {\n    font-size: 26px;\n  }\n  .carousel-caption {\n    padding: 0.6rem;\n  }\n}","// Scrolling Text Section Styles\n.scrolling-text-section {\n  background-color: var(--surface, #f9f9f9);\n  padding: 30px 0;\n  margin: 20px 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(207, 171, 141, 0.2);\n  border-bottom: 1px solid rgba(207, 171, 141, 0.2);\n\n  .scrolling-text-container {\n    width: 100%;\n    overflow: hidden;\n    background: linear-gradient(to right, transparent, rgba(207, 171, 141, 0.1), transparent);\n    padding: 10px 0;\n  }\n\n  .scrolling-text {\n    display: flex;\n    animation: scroll-left 20s linear infinite;\n\n    p {\n      margin: 0;\n      white-space: nowrap;\n      padding: 15px 50px;\n      font-size: 16px;\n      font-weight: 500;\n      color: var(--ink, #111);\n\n      a {\n        color: var(--accent, #CFAB8D);\n        text-decoration: none;\n        font-weight: 600;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n// Scrolling Images Section Styles\n.scrolling-images-section {\n  background-color: var(--bg, #ECEEDF);\n  padding: 60px 0;\n  margin: 20px 0;\n  overflow: hidden;\n\n  .scrolling-images-container {\n    width: 100%;\n    overflow: hidden;\n  }\n\n  .scrolling-images {\n    display: flex;\n    animation: scroll-images 30s linear infinite;\n    gap: 20px;\n    padding: 20px 0;\n  }\n\n  .scrolling-image {\n    flex: 0 0 200px;\n    height: 150px;\n    object-fit: cover;\n    border-radius: 8px;\n    box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n    transition: transform 0.3s ease;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n  }\n}\n\n@keyframes scroll-images {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n// Countdown/Updates Section Styles\n.countdown-timer {\n  background-color: var(--surface, #f9f9f9);\n  padding: 80px 0;\n  margin: 20px 0;\n\n  .heading-count {\n    margin-bottom: 50px;\n    text-align: center;\n\n    h2 {\n      font-size: 32px;\n      font-weight: 700;\n      color: var(--ink, #111);\n      margin: 0 0 20px 0;\n    }\n  }\n\n  .time-countdown {\n    margin-bottom: 60px;\n\n    ul {\n      list-style: none;\n      padding: 0;\n      text-align: justify;\n\n      li {\n        margin-bottom: 18px;\n        padding: 12px 0;\n        font-size: 14px;\n        line-height: 1.8;\n        color: var(--ink, #111);\n        border-bottom: 1px solid rgba(207, 171, 141, 0.1);\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        a {\n          color: var(--accent, #CFAB8D);\n          text-decoration: none;\n          font-weight: 500;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n\n        .flash-red {\n          color: #e74c3c;\n          font-weight: 600;\n          animation: flash 1s infinite;\n        }\n      }\n    }\n  }\n\n  .registration-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 50px 0;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n\n    thead {\n      background-color: var(--accent, #CFAB8D);\n      color: white;\n\n      th {\n        padding: 16px;\n        text-align: left;\n        font-weight: 600;\n        font-size: 14px;\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #e0e0e0;\n\n        &:hover {\n          background-color: rgba(207, 171, 141, 0.1);\n        }\n\n        td {\n          padding: 16px;\n          font-size: 14px;\n          color: var(--ink, #111);\n        }\n      }\n    }\n  }\n\n  .registration-note2,\n  .registration-note {\n    background-color: #fff3cd;\n    border-left: 4px solid var(--accent, #CFAB8D);\n    padding: 18px;\n    margin: 20px 0;\n    border-radius: 4px;\n    font-size: 14px;\n    color: var(--ink, #111);\n    line-height: 1.6;\n  }\n}\n\n@keyframes flash {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n// Important Dates Section Styles\n.important-dates {\n  background-color: var(--bg, #ECEEDF);\n  padding: 80px 0;\n  margin: 20px 0;\n\n  h2 {\n    font-size: 32px;\n    font-weight: 700;\n    color: var(--ink, #111);\n    margin-bottom: 50px;\n    text-align: center;\n  }\n\n  .table {\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: var(--shadow-sm, 0 2px 4px rgba(0, 0, 0, 0.1));\n    margin-bottom: 40px;\n\n    thead {\n      background-color: var(--accent, #CFAB8D);\n      color: white;\n\n      th {\n        padding: 16px;\n        text-align: left;\n        font-weight: 600;\n        border: none;\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #e0e0e0;\n\n        &:hover {\n          background-color: rgba(207, 171, 141, 0.1);\n        }\n\n        td {\n          padding: 16px;\n          font-size: 14px;\n          color: var(--ink, #111);\n          border: none;\n          line-height: 1.6;\n\n          strong {\n            color: var(--accent, #CFAB8D);\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Sponsor Section Styles\n#sponsor_ribbon {\n  background-color: var(--surface, #f9f9f9);\n  padding: 80px 0;\n  margin: 20px 0;\n\n  .sponsor-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 40px;\n    justify-content: center;\n    align-items: center;\n\n    a {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      transition: transform 0.3s ease, opacity 0.3s ease;\n\n      &:hover {\n        transform: scale(1.1);\n        opacity: 0.8;\n      }\n    }\n\n    .sponsor-logo {\n      max-height: 80px;\n      object-fit: contain;\n      filter: grayscale(30%);\n      transition: filter 0.3s ease;\n\n      &:hover {\n        filter: grayscale(0%);\n      }\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .scrolling-text-section {\n    padding: 20px 0;\n    margin: 15px 0;\n\n    .scrolling-text p {\n      padding: 12px 30px;\n      font-size: 14px;\n    }\n  }\n\n  .scrolling-images-section {\n    padding: 40px 0;\n    margin: 15px 0;\n\n    .scrolling-images {\n      gap: 15px;\n      padding: 15px 0;\n    }\n  }\n\n  .scrolling-image {\n    flex: 0 0 150px !important;\n    height: 120px !important;\n  }\n\n  .countdown-timer {\n    padding: 60px 0;\n    margin: 15px 0;\n\n    .heading-count {\n      margin-bottom: 40px;\n\n      h2 {\n        font-size: 26px;\n        margin-bottom: 15px;\n      }\n    }\n\n    .time-countdown {\n      margin-bottom: 40px;\n\n      ul li {\n        margin-bottom: 15px;\n        padding: 10px 0;\n        font-size: 13px;\n      }\n    }\n\n    .registration-table,\n    .table {\n      font-size: 12px;\n      margin: 30px 0;\n\n      th, td {\n        padding: 12px !important;\n      }\n    }\n\n    .registration-note2,\n    .registration-note {\n      padding: 15px;\n      margin: 15px 0;\n      font-size: 13px;\n    }\n  }\n\n  .important-dates {\n    padding: 60px 0;\n    margin: 15px 0;\n\n    h2 {\n      font-size: 26px;\n      margin-bottom: 40px;\n    }\n\n    .table {\n      font-size: 12px;\n\n      th, td {\n        padding: 12px !important;\n      }\n    }\n  }\n\n  #sponsor_ribbon {\n    padding: 60px 0;\n    margin: 15px 0;\n\n    .sponsor-container {\n      gap: 25px;\n\n      .sponsor-logo {\n        max-height: 70px;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .scrolling-text-section {\n    padding: 15px 0;\n    margin: 10px 0;\n\n    .scrolling-text p {\n      padding: 10px 20px;\n      font-size: 13px;\n    }\n  }\n\n  .scrolling-images-section {\n    padding: 30px 0;\n    margin: 10px 0;\n\n    .scrolling-images {\n      gap: 10px;\n      padding: 10px 0;\n    }\n  }\n\n  .scrolling-image {\n    flex: 0 0 120px !important;\n    height: 100px !important;\n  }\n\n  .countdown-timer {\n    padding: 40px 0;\n    margin: 10px 0;\n\n    .heading-count {\n      margin-bottom: 30px;\n\n      h2 {\n        font-size: 22px;\n        margin-bottom: 15px;\n      }\n    }\n\n    .time-countdown {\n      margin-bottom: 30px;\n\n      ul li {\n        margin-bottom: 12px;\n        padding: 8px 0;\n        font-size: 12px;\n      }\n    }\n\n    .registration-table,\n    .table {\n      font-size: 11px;\n      margin: 20px 0;\n\n      th, td {\n        padding: 10px !important;\n        font-size: 11px;\n      }\n    }\n\n    .registration-note2,\n    .registration-note {\n      padding: 12px;\n      margin: 12px 0;\n      font-size: 12px;\n    }\n  }\n\n  .important-dates {\n    padding: 40px 0;\n    margin: 10px 0;\n\n    h2 {\n      font-size: 22px;\n      margin-bottom: 30px;\n    }\n\n    .table {\n      font-size: 11px;\n\n      th, td {\n        padding: 10px !important;\n      }\n    }\n  }\n\n  #sponsor_ribbon {\n    padding: 40px 0;\n    margin: 10px 0;\n\n    .sponsor-container {\n      gap: 15px;\n\n      .sponsor-logo {\n        max-height: 60px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
